<template>
  <div class="dig" >
    <b-form
      class="form"
      @submit.prevent="onSubmit"
      @reset="onReset"
      novalidate
      inline
      >
      <b-form-group
        id="input-group-5"
        label="姓名"
        label-for="input-5"
        class="input_Body"
      >
        <el-input type="text" size="mini" v-model="form.name" @blur="getCode3" placeholder="请输入姓名"></el-input>
        <p class="err" id="err_phonenum" v-show="name">
          <span class="yanzh">{{ name }}</span>
        </p>
      </b-form-group>
      <b-form-group
        id="input-group-6"
        label="手机号"
        label-for="input-5"
        class="input_Body"
      >
      <el-input type="number" size="mini" v-model="form.mobile" @blur="getCode4" placeholder="请输入手机号"></el-input>
        <p class="err" id="err_phonenum" v-show="telephone1">
          <span class="yanzh">{{ telephone1 }}</span>
        </p>
      </b-form-group>
      <b-form-group
        id="input-group-8"
        label="公司名称"
        label-for="input-5"
        class="input_Body"
      >
      <el-input type="tetx" size="mini" v-model="form.company_name" @blur="getCode2" placeholder="请输入公司名称"></el-input>
        <p class="err" id="err_phonenum" v-show="compname">
          <span class="yanzh">{{ compname }}</span>
        </p>
      </b-form-group>
      <b-form-group
        id="input-group-9"
        label="公司性质"
        label-for="input-5"
        class="input_Body"
      >
        <el-select
          class="enemt"
          v-model="form.company_type"
          clearable
          size="mini"
          @change="getCode"
          placeholder="请选择类型"
        >
          <el-option
            v-for="item in foods"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <p class="err" id="err_phonenum" v-show="type">
          <span class="yanzh">{{ type }}</span>
        </p>
      </b-form-group>
      <b-button type="submit" class="btn" variant="primary" >立即合作</b-button>
    </b-form>
  </div>
</template>
<script>
import request from"../../../utils/request"
export default {
  name:'dialog1',
  props:['id'],
  data(){
    return{
      form:{
        id:null,
        name:'',
        company_type:'',
        company_name:'',
        mobile:'',
      },
      foods:[
        '制造',
        '批发',
        '零售'
      ],
      compname:'',
      name:'',
      telephone1:'',
      type:'',
    }
  },
  methods:{
    add(){
      if(this.id){
        this.form.id=this.id
      }
      this.$emit('add',this.form)
    },
    getCode() {
      //获取手机验证码
      if (!this.form.company_type) {
        this.type = "请选择公司性质";
        return false;
      } else {
        this.type = "";
      }
    },
    getCode2() {
      //获取手机验证码
      if (!this.form.company_name) {
        this.compname = "请输入公司";
        return false;
      } else {
        this.compname = "";
      }
    },
    getCode3() {
      //获取手机验证码
      if (!this.form.name) {
        this.name = "请输入姓名";
        return false;
      } else {
        this.name = "";
      }
    },
    getCode4() {
      //获取手机验证码
      let reg = /^1[3-9][0-9]{9}$/; //以1开头第二位数字为3-9 的11位数字
      if (!reg.test(this.form.mobile)) {
        this.telephone1 = "请输入正确的手机号";
        return false;
      } else {
        this.telephone1 = "";
        return true
      }
    },
    onSubmit(evt) {
      this.getCode()
      this.getCode2()
      this.getCode3()
     let aa= this.getCode4()
      if(!aa){
        return
      }else{
        this.add()
      }
    },
    onReset(evt) {
      
    }
  }
}
</script>
<style scoped>
div /deep/.el-input__inner::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: black;
}
.dig{
  background-color: #ffffffbd;
  padding: 18px;
  border-radius: 10px;
  padding-top: 32px;
  border: 1px solid #c0c4cc;
  box-shadow: 0px 0px 10px #0d6efd78;
}
.enemt{
  width: 273px;
}
.yanzh {
  color: red;
  /* position: absolute; */
  /* margin-left: 35px; */
  padding: 0;
}
.err{
  text-align: left;
  position: absolute;
  font-size: 12px;
}
.btn{
  height: 31px;
    width: 115px;
    font-size: 12px;
}
div /deep/.d-block{
  text-align: left;
  font-size: 13px;
}
div /deep/ .form-control{
  height: 28px;
}
.input_Body{
  margin: 0 5px;
  margin-bottom: 22px;
  position: relative;
}
</style>